<app-question-card>
  <p question>Got it!</p>
  <p class="desc" question>Are you also looking to buy a property?</p>
  <div class="form-field" input-options>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="BuyingWithSellingOptions.JUST_SELL"
        name="home-buy"
        [value]="BuyingWithSellingOptions.JUST_SELL"
        [(ngModel)]="buyingWithSelling"
        (click)="submit(BuyingWithSellingOptions.JUST_SELL)"
      />
      <label [for]="BuyingWithSellingOptions.JUST_SELL">
        {{BuyingWithSellingOptionsLabel.JUST_SELL}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="BuyingWithSellingOptions.BUY_WTH_SELL"
        name="home-buy"
        [value]="BuyingWithSellingOptions.BUY_WTH_SELL"
        [(ngModel)]="buyingWithSelling"
        (click)="submit(BuyingWithSellingOptions.BUY_WTH_SELL)"
      />
      <label [for]="BuyingWithSellingOptions.BUY_WTH_SELL">
        {{BuyingWithSellingOptionsLabel.BUY_WTH_SELL}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="BuyingWithSellingOptions.NA"
        name="home-buy"
        [value]="BuyingWithSellingOptions.NA"
        [(ngModel)]="buyingWithSelling"
        (click)="submit(BuyingWithSellingOptions.NA)"
      />
      <label [for]="BuyingWithSellingOptions.NA">
        {{BuyingWithSellingOptionsLabel.NA}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
  </div>
  <p class="chat-answer" answer>{{BuyingWithSellingOptionsLabel[buyingWithSelling!]}}</p>
</app-question-card>
